import { styled } from '@mui/material';
import { ReactNode } from 'react';

const StyledContainer = styled('div')<{ variant?: 'narrow' }>(
  ({ theme, variant }) => ({
    display: 'flex',
    gap: theme.spacing(10),
    flexDirection: 'column',
    maxWidth: variant === 'narrow' ? 800 : 1200,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(4),
  })
);

export type ContainerProps = {
  children: ReactNode;
  variant?: 'narrow';
};

export const Container = ({ children, variant }: ContainerProps) => {
  return <StyledContainer variant={variant}>{children}</StyledContainer>;
};
